import React, { useEffect } from "react";
import LinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";

export type EmtLinearProgressProps = LinearProgressProps & {
  /**
   * Time duration in millisecond
   * @default 500
   */
  time?: number;
  nonce?: string;
};

export function EmtLinearProgress(props: EmtLinearProgressProps) {
  const { time = 500, variant = "determinate", value = 0, ...rest } = props;
  const [progress, setProgress] = React.useState(value);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, time);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Box sx={{ width: "100%" }}>
      <LinearProgress variant={variant} value={progress} {...rest} />
    </Box>
  );
}
